import { create } from 'zustand';
import { WebSocketService } from '../services/WebSocketService';

type WebSocketState = {
  status: 'CONNECTING' | 'OPEN' | 'CLOSING' | 'CLOSED' | 'NOT_INITIALIZED';
  lastMessage: unknown | null;
  connect: (url: string) => void;
  disconnect: () => void;
  sendMessage: (message: unknown) => void;
};

// Single status-poll interval, cleared on reconnect/disconnect so
// remounts don't stack intervals
let statusIntervalId: ReturnType<typeof setInterval> | null = null;

export const useWebSocketStore = create<WebSocketState>((set) => ({
  status: 'NOT_INITIALIZED',
  lastMessage: null,
  connect: (url: string) => {
    const wsService = WebSocketService.getInstance(url);
    wsService.setMessageHandler((message) => {
      set({ lastMessage: message });
    });
    wsService.connect();

    const updateStatus = () => {
      set({ status: wsService.getStatus() });
    };

    updateStatus();
    if (statusIntervalId) {
      clearInterval(statusIntervalId);
    }
    statusIntervalId = setInterval(updateStatus, 1000);
  },
  disconnect: () => {
    if (statusIntervalId) {
      clearInterval(statusIntervalId);
      statusIntervalId = null;
    }
    const wsService = WebSocketService.getInstance('');
    wsService.disconnect();
    set({ status: 'CLOSED' });
  },
  sendMessage: (message: unknown) => {
    const wsService = WebSocketService.getInstance('');
    wsService.sendMessage(message);
  },
}));
